import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import {
  getCurrentPnr,
  isViajaAhorrandoActive,
  getViajaAhorrandoTrips,
} from 'selectors/viajeAhorrandoSelector';

/**
 * useViajaAhorrando hook.
 * Provides access to Viaja Ahorrando discount data from the Redux store.
 * Memoizes trip normalization and the entire return object.
 *
 * @returns {Object} Viaja Ahorrando data (memoized)
 * @returns {string|null} returns.currentPnr - Current PNR code
 * @returns {Array} returns.trips - Array of discounted trip objects
 * @returns {boolean} returns.isActive - Whether Viaja Ahorrando discount is active
 */
const useViajaAhorrando = () => {
  const currentPnr = useSelector(getCurrentPnr);
  const isActive = useSelector(isViajaAhorrandoActive);

  const rawTrips = useSelector(getViajaAhorrandoTrips);

  // Memoize normalization to a plain array to avoid unnecessary conversions on every render
  const trips = useMemo(() => {
    if (Array.isArray(rawTrips)) return rawTrips;
    if (rawTrips && rawTrips.toJS) return rawTrips.toJS();
    return [];
  }, [rawTrips]);

  return {
    currentPnr,
    trips,
    isActive,
  };
};

export default useViajaAhorrando;
